export const DEFAULT_NOTIFICATION_SOUND_TYPE = 'classic';

// `userSelectable: false` keeps a preset out of the preference picker but
// still reachable for system-driven playback (e.g. the @mention boost
// resolves `'mention'` regardless of the user's chosen default). The
// backend allowlist (src/functions/message-handler/domain/notification-preference.js)
// must match the user-selectable subset — adding a system-only preset
// here without adding it there is intentional.
export const NOTIFICATION_SOUND_PRESETS = [
  { type: 'classic', label: 'Classic Ding', src: '/sounds/notifications/classic.wav', userSelectable: true },
  { type: 'pop', label: 'Pop', src: '/sounds/notifications/pop.wav', userSelectable: true },
  { type: 'chime', label: 'Chime', src: '/sounds/notifications/chime.wav', userSelectable: true },
  { type: 'glass', label: 'Glass', src: '/sounds/notifications/glass.wav', userSelectable: true },
  { type: 'sonar', label: 'Sonar', src: '/sounds/notifications/sonar.wav', userSelectable: true },
  { type: 'mention', label: 'Mention (system)', src: '/sounds/notifications/mention.wav', userSelectable: false }
];

export const USER_SELECTABLE_NOTIFICATION_SOUND_PRESETS = NOTIFICATION_SOUND_PRESETS.filter(
  (preset) => preset.userSelectable !== false
);

export const NOTIFICATION_SOUND_TYPE_SET = new Set(
  NOTIFICATION_SOUND_PRESETS.map((preset) => preset.type)
);

const PRESET_BY_TYPE = NOTIFICATION_SOUND_PRESETS.reduce((acc, preset) => {
  acc[preset.type] = preset;
  return acc;
}, {});

export function resolveNotificationSoundType(soundType) {
  const candidate = String(soundType || '').trim().toLowerCase();
  if (NOTIFICATION_SOUND_TYPE_SET.has(candidate)) return candidate;
  return DEFAULT_NOTIFICATION_SOUND_TYPE;
}

export function getNotificationSoundSrc(soundType) {
  const resolvedType = resolveNotificationSoundType(soundType);
  return PRESET_BY_TYPE[resolvedType].src;
}
